module.exports = flarum.core.compat['extensions/afrux-forum-widgets-core/forum/components/TopWidgetSection'];